module.exports = __webpack_public_path__ + "img/point_golden.963cc09c.svg";